"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiProvider = void 0;
class MultiProvider {
    constructor(providers) {
        this.providers = [];
        this.providers = providers;
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        yield this.providers[i].connect();
                    }
                }
                catch (_) {
                    continue;
                }
            }
        });
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    yield yield this.providers[i].close();
                }
                catch (_) {
                    continue;
                }
            }
        });
    }
    _doesNotImplementError() {
        throw new Error("MultiProvider could not find an active Provider that implements this method.");
    }
    getNetworkId() {
        for (let i = 0; i < this.providers.length; ++i) {
            try {
                if (!this.providers[i].isConnected()) {
                    continue;
                }
                return this.providers[i].getNetworkId();
            }
            catch (_) {
                continue;
            }
        }
        return this._doesNotImplementError();
    }
    isConnected() {
        for (let i = 0; i < this.providers.length; ++i) {
            try {
                if (this.providers[i].isConnected())
                    return true;
            }
            catch (_) {
                continue;
            }
        }
        return false;
    }
    getBlockNumber() {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].getBlockNumber();
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    getBalance(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].getBalance(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    subscribeToPuzzleHashUpdates(args) {
        for (let i = 0; i < this.providers.length; ++i) {
            try {
                if (!this.providers[i].isConnected()) {
                    continue;
                }
                return this.providers[i].subscribeToPuzzleHashUpdates(args);
            }
            catch (_) {
                continue;
            }
        }
        return this._doesNotImplementError();
    }
    subscribeToCoinUpdates(args) {
        for (let i = 0; i < this.providers.length; ++i) {
            try {
                if (!this.providers[i].isConnected()) {
                    continue;
                }
                return this.providers[i].subscribeToCoinUpdates(args);
            }
            catch (_) {
                continue;
            }
        }
        return this._doesNotImplementError();
    }
    getPuzzleSolution(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].getPuzzleSolution(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    getCoinChildren(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].getCoinChildren(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    getBlockHeader(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].getBlockHeader(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    getBlocksHeaders(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].getBlocksHeaders(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    getCoinRemovals(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].getCoinRemovals(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    getCoinAdditions(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].getCoinAdditions(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    getAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].getAddress();
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    pushSpendBundle(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].pushSpendBundle(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    transfer(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].transfer(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    transferCAT(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].transferCAT(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    acceptOffer(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].acceptOffer(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    subscribeToAddressChanges(args) {
        for (let i = 0; i < this.providers.length; ++i) {
            try {
                if (!this.providers[i].isConnected()) {
                    continue;
                }
                return this.providers[i].subscribeToAddressChanges(args);
            }
            catch (_) {
                continue;
            }
        }
        return this._doesNotImplementError();
    }
    signCoinSpends(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].signCoinSpends(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
    changeNetwork(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.providers.length; ++i) {
                try {
                    if (!this.providers[i].isConnected()) {
                        continue;
                    }
                    return yield this.providers[i].changeNetwork(args);
                }
                catch (_) {
                    continue;
                }
            }
            return this._doesNotImplementError();
        });
    }
}
exports.MultiProvider = MultiProvider;
//# sourceMappingURL=multi_provider.js.map